import React from "react";
import  { useState, useEffect } from 'react';
import './classes/SoccerEducationProgram.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';

const SoccerEducationProgram = () => {

    // const navigate = useNavigate();
    // const app_url = configData.APP_URL;
   const [isLoading, setIsLoading] = useState(true);
   const [mentors, setMentors] = useState([]);
   const [courseTopics, setCourseTopics] = useState([]);
   const [testimonialsData, setTestimonialsData] = useState([]);

    useEffect(() => {
        const mentors = [
             {
                name: "Tommy Smyth", 
                image: "/basic/web/images/scout/Smyth_Tommy.jpg",               
                description1:'Since 1993, Irish born <strong>Tommy Smyth </strong>has been an integral part of ESPN soccer coverage for the MLS, EPL, Serie A, La Liga, UEFA Champions League and FIFA World Cup Qualifying matches. His in-game analysis, strategic expertise and player evaluations are unmatched, as are his trademark voice and excitable delivery. Smyth is also well known for his studio work, anchoring ESPN Soccernet Press Pass, ESPN International’s global football roundtable and analysis segments covering the game the world over.',
                description2:'During his tenure at ESPN, Smyth has called over 3,000 international matches, giving him an unprecedented point of view into team dynamics, attributes and organization. It is this knowledge of the sport, and first hand exposure to the global game, that makes Smyth such a valued course mentor.',
             },   
                {
                name: "Matt Martin",
                image: "/basic/web/images/scout/Matt_Martin_Timbers_headshot.jpg",               
                description1:'As the Director of Domestic Scouting for the Portland Timbers of the MLS,<strong>Matt Martin</strong>  is focused on scouting USL, NASL, NCAA and MLS matches in the USA. He coordinates and manages the efforts of a team of regional scouts for recruitment and advance scouting purposes. Before joining the Timbers Martin was the National Scouting Coordinator for Sporting Kansas City, covering the East Coast, and a scout with the New York Red Bulls.',
                description2:'Matt’s professional career began with The Scouting Network (TSN) out of Birmingham, England after completing SMWW’s Soccer Management and Scouting Course in 2007. Now he’s a course mentor, and a highly connected resource in the world of domestic soccer.  In fact, the entire scouting staff of the Portland Timbers are graduates of Sports Management Worldwide Soccer Management & Scouting course. Martin’s reach extends far beyond the Pacific Northwest; he knows firsthand which teams are hiring within professional and college soccer and has helped place many course graduates in soccer careers.',
             }, 
                {
                name: "John Print",
                image: "/basic/web/images/scout/John_Print_Photo(1).jpg",               
                description1:'<strong>John Print</strong>  is SMWW UK Operations Manager and Director of Soccer. John is a Licensed Player’s Agent by the English FA with a jurisdiction to represent players and clubs worldwide. With years of experience, Print has built up a large number of worldwide contacts within the game which are invaluable to SMWW and our students.',
                description2:'Besides working in football, John also represents a number of Olympic athletes and other sports personalities. His experience of sports marketing and client management allows his clients to maximize their potential whilst competing and away from their chosen sport.',
             }, 
                {
                name: "Richard Trafford",
                image: "/basic/web/images/scout/richardtrafford.jpg",               
                description1:'As a licensed FA agent and the Director of Operations for the UK and US operations of Wyscout, <strong>Richard Trafford</strong>  has a diverse skill set ideally suited for teaching soccer analytics.With over 10 years’ experience in sports marketing, and having previously worked at Sports International Management, Cassius Management and the Kentaro group, Richard brings a wealth of experience to player management and analytics.',
                description2:'A graduate of the SMWW Athlete Management course and a speaker at many of our soccer conferences, Richard’s personality and advanced knowledge of soccer will enlighten and entertain students.',
             },    
                {
                name: "Wyscout",
                image: "/basic/web/images/scout/picture-2464-1447856442.jpg",               
                description1:'One of the companies leading the charge in soccer analytics is <strong>Wyscout</strong> , whose video analytics platform is used by over 500 clubs and 4,000 soccer professionals across the globe. This is the only course in the world that will help you become an advancedWyscout user, and that’s just the beginning of what this course has to offer.',
             },    
            
        ];
        setMentors(mentors);

        const courseTopics = [
            "Soccer/football Scouting, player evaluation, player ratings and in-depth analysis",
            "University, Club, and International Scouting",
            "Collegiate soccer scouting versus U16 and U18 players",
            "Relationships between scouting soccer leagues in the US, Europe, South America, Asia, Middle East, and Africa",
            "Methods of ranking soccer talent",
            "Team evaluation vs. individual evaluation",
            "Evaluating offensive schemes/formations",
            "Soccer Scouting player evaluation; body type, mental makeup, playing ability, physical tools",
            "Learn to identify players who will succeed at various international levels",
            "Traditional soccer scouting vs. new high tech scouting and digital video editing",
            "The making of a soccer scouting report",
            "Concise and indepth soccer scouting terminology",
            "Collegiate soccer scouting versus high school players",
            "Methods of ranking high-school and college soccer talent",
            ];
        setCourseTopics(courseTopics);

           const initialTestimonials  = [
        {
            id: 1,
            name: "Mike Ablett",
            title: "Austin Herd Chief Marketing Officer",
            image:
            "/basic/web/images/scout/picture-2556-1454348562.jpg",
            link: "/testimonial/mike-ablett",
            body: `The Rugby Business Management Course is a must for any one who is involved in Rugby or is looking at pursuing a career in Rugby Administration. The personal attention and weekly audio chats were great and it created an open forum to compare, debate and analyze the game we love.  `
        }
        ];
   setTestimonialsData(initialTestimonials);

    },[]);

    useEffect(() => {
        Promise.all([
            
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    // const handleClick = (continent) => {
    //     navigate('/continents/'+continent+'/scouts');
    // };
    
    
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" className="soccer-education-progarm-main">
                <Helmet><title>Soccer Scout Education</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                   <div className="soccer-education-progarm-container">
                    <div className="scouting-mentors">                        
                            <h1>SMWW Soccer Education Program</h1>
                            <p>SMWW Soccer Scouts have been trained and mentored by some of the best in the industry. SMWW Soccer Scouts have completed a rigorous eight week training program and instructed by Tommy Smyth, Matt Martin, John Print, Richard Trafford and Wyscout. SMWW Soccer Scouts are listed here with scouting report samples. Please contact them and arrange a complimentary scouting report for your program, be it at the school, university, club, or professional level.</p>
                            <h2>SMWW Soccer Scouting Mentors:</h2>
                             {mentors.map((mentor,index) => (
                                <div className="scout-mentors" key={mentor.name} style={{ marginBottom: "1.5rem", overflow: "auto" }}>
                                <img
                                    src={mentor.image}
                                    alt={mentor.name}
                                    className={`mentor-image mentor-image-${index}`}
                                />
                                <p>
                                    <span dangerouslySetInnerHTML={{ __html: mentor.description1 }} />
                                </p>
                                <p>{mentor.description2}</p>                               
                                </div>
                            ))}
                            <h2>SMWW Soccer Scouts have successfully completed 8 weeks of training including:</h2>
                                <ul>
                                    {courseTopics.map((topic, index) => (
                                    <li key={index}>{topic}</li>
                                    ))}
                                </ul>
                               <div style={{ clear: "both", textAlign: "center", marginBottom: "10px" }}>
                                <a className="reddbtnn" href="http://www.sportsmanagementworldwide.com/application">
                                Apply today for training as an SMWW Certified Soccer Scout
                                </a>
                               </div>
                            <p>
                                <p>&nbsp;</p>
                            <span><strong><a href="/scout-sports/soccer">Click here</a>  to search for a SMWW Soccer Scout by Area.    </strong><br/>
                            SMWW Scouts will do a complimentary scouting report to your specifications to prove they are an expert.</span></p>
                            <p><strong><em>SMWW Scouts will be an exceptional resource to save you time and money in your program!</em></strong></p>
                    </div>
                  
                    </div>
                </div>
            </div>
        )}
        </>
    );
};
export default SoccerEducationProgram;